import { getValue } from "@utils/lodash";
import React, { useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
function UserEntityTable(props: any) {
  return (
    <div className="user-entity-table-container">
      <table>
        <thead>
          {getValue(props, `headerList`, []).map(
            (item: object, index: number) => {
              return (
                <th key={index}>
                  <h5 className="header">{getValue(item, `group_name`, "")}</h5>
                  {/* <p className="subHeader">name</p> */}
                </th>
              );
            }
          )}
          <th>Action</th>
        </thead>
        <tbody>
          {getValue(props, `assignedList`, []).map(
            (item: object, key: number) => {
              return (
                <React.Fragment>
                  <tr key={key}>
                    {getValue(props, `headerList.length`, 0) > 0 &&
                      getValue(props, `headerList`, []).map((header: any) => (
                        <td>
                          {getValue(
                            item,
                            `[${`level_${getValue(
                              header,
                              `group_level`,
                              ""
                            )}`}].ic_entity_name`,
                            ""
                          )}
                        </td>
                      ))}
                    <td>
                      {getValue(props, `permissions`, []).includes(
                        "delete"
                      ) && (
                        <img
                          src="/images/list-management/country/delete-icon.svg"
                          className="img-fluid close-btn cursor-pointer"
                          style={{
                            height: "30px",
                            width: "30px",
                          }}
                          onClick={() =>
                            props.handleDeleteEntity(
                              getValue(item, `id`, ""),
                              ""
                            )
                          }
                        />
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              );
            }
          )}
        </tbody>
      </table>
    </div>
  );
}

export default UserEntityTable;
